/* eslint-disable camelcase */

'use client';

import { useSearchParams } from 'next/navigation';
import MasterLayout from '@/app/components/layout/master-layout';
import { ManagePlaylistView } from './manage-playlist-view';

export default function ManagePlaylist() {
  const searchParams = useSearchParams();
  const type = searchParams.get('type');
  const mac_address = searchParams.get('mac_address');
  const device_key = searchParams.get('device_key');

  return (
    <MasterLayout>
      <ManagePlaylistView type={type} macAddress={mac_address} deviceKey={device_key} />
    </MasterLayout>
  );
}
